import './team-header.styles.scss';
import { recordText, streakText } from '@/utils/leagueLabels';
import TeamBadge from '@/components/SHARED/team-badge/team-badge.component';
import HelpLink from '@/components/SHARED/help-link/help-link.component';
import { Top25Context } from '@/utils/top25';
import { useContext } from 'react';
import { hometownText } from '@shared/places.js';
import { conferencePrestige } from '@shared/prestige.js';
import PrestigeStars from '@/components/SHARED/prestige-stars/prestige-stars.component';

// Badge, name, record and chemistry grade for a team page.
// team: team document or summary row. meta: text under the name, after
// the team's hometown.
// extra: added to the stats line. actions: buttons on the right.
// league and teams (the summary map), when given for a college league, add
// the program's and its conference's prestige.
const TeamHeader = ({ team, meta, extra, actions, league, teams }) => {
    const r = team.record;
    const rank = useContext(Top25Context)[team.id];
    const college = league && league.type !== 'pro';
    const confPrestige = college && teams ? conferencePrestige(Object.values(teams))[team.conference] : null;
    return (
        <div className='g-card team-header'>
            <TeamBadge team={team} size='lg' />
            <div className='team-header-text'>
                <h2>{team.name} <span className='mascot'>{team.mascot}</span>{rank && <span className='top25-rank'> ({rank})</span>}</h2>
                {(meta || hometownText(team)) && <div className='meta'>{[hometownText(team), meta].filter(Boolean).join(' · ')}</div>}
                <div className='team-stats'>
                    <span><b>{recordText(r)}</b> overall</span>
                    <span><b>{r.confW}-{r.confL}</b> conf</span>
                    <span>Streak <b>{streakText(r.streak)}</b></span>
                    <span title='Team chemistry, graded across the whole roster'>
                        Chemistry <b>{team.chemistryGrade?.grade ?? '-'}</b>
                        <HelpLink section='chemistry' label='How chemistry works' />
                    </span>
                    {college && <span>Program <PrestigeStars value={team.prestige} label='Program prestige' /></span>}
                    {confPrestige && <span>Conference <PrestigeStars value={confPrestige} label='Conference prestige' /></span>}
                    {extra}
                </div>
            </div>
            {actions && <div className='team-header-actions'>{actions}</div>}
        </div>
    )
}

export default TeamHeader
